import React, { Component } from 'react';
import { Translation } from 'react-i18next';
import { Card, Col, Row, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import UserAccountForm from '../containers/UserAccountFormContainer';
import UserAccountAlertsForm from '../containers/UserAccountAlertsFormContainer';
import UpdatePasswordForm from '../containers/UpdatePasswordFormContainer';
import UserAvatarForm from '../containers/UserAvatarFormContainer';
import TwoFactorSettingsForm from '../containers/TwoFactorSettingsFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class UserAccountScreen extends Component {
  scrollToTop = () => {
    Logger.log('debug', `UserAccountScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  render() {
    const loadingIcon = (
      <Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />} />
    );
    return (
      <Translation>
        {(t) => (
          <div>
            <DocumentHead title={t('user_account_route_manage')} />

            <Row gutter={24}>
              <Col xl={12} lg={24} md={24} sm={24} xs={24}>
                <Card
                  title={t('user_account_form_title')}
                  extra={this.props.isLoading ? loadingIcon : null}
                >
                  <UserAccountForm />
                </Card>

                <Card title={t('password_form_title')}>
                  <UpdatePasswordForm />
                </Card>

                {this.props.oneTimePassword === 2 ? (
                  <Card
                    title={t('user_account_2fa_form_title')}
                    extra={this.props.isSubmitting2FA ? loadingIcon : null}
                  >
                    <TwoFactorSettingsForm />
                  </Card>
                ) : null}
              </Col>

              <Col xl={12} lg={24} md={24} sm={24} xs={24}>
                <Card title={t('user_avatar_form_title')}>
                  <UserAvatarForm />
                </Card>

                <Card
                  title={t('user_account_alerts_form_title')}
                  extra={this.props.isLoading ? loadingIcon : null}
                >
                  <UserAccountAlertsForm />
                </Card>
              </Col>
            </Row>
          </div>
        )}
      </Translation>
    );
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    Logger.log('silly', `UserAccountScreen.componentDidMount()`);
    this.scrollToTop();
  }

  componentDidUpdate() {
    Logger.log('silly', `UserAccountScreen.componentDidUpdate()`);
  }

  componentWillUnmount() {
    Logger.log('silly', `UserAccountScreen.componentWillUnmount()`);
  }
}

export default UserAccountScreen;

Logger.log('silly', `UserAccountScreen loaded.`);
